import { cn } from '../lib/utils';

/** The parent company's site — both products are Agentic Flow Studios offerings. */
export const AGENTIC_FLOW_URL = 'https://agentic-flow.studio';

/**
 * Parent-company attribution: a quiet link out to agentic-flow.studio.
 *
 * Belongs in footer positions — the bottom of a signed-out page, the bottom of the app
 * sidebar — not in the brand lockup itself, where it competes with the product name.
 */
export function AgenticFlowByline({ className }: { className?: string }) {
  return (
    <a
      href={AGENTIC_FLOW_URL}
      target="_blank"
      rel="noreferrer"
      className={cn(
        'text-[11px] tracking-wide text-muted-foreground/70 transition-colors hover:text-foreground',
        className
      )}
    >
      by Agentic Flow Studios
    </a>
  );
}
